(function() {
    'use strict';

    angular
        .module('lariAidApp')
        .config(stateConfig);
    
    stateConfig.$inject = ['$stateProvider','APP'];
    
    function stateConfig($stateProvider,APP) {
        $stateProvider.state('entities', {
            parent: 'library',
            url: '/entities',
            data: {
                authorities: APP.GLOBAL.USER_GROUP
            },
            params: {
            	libraryType:null
            },
            views: {
                'libraryList': {
                    templateUrl: 'app/library/entity/library.entities.html',
                    controller: 'LibraryEntityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('dashboard.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('dashboard.json?timestamp='+new Date().getTime());
                       }
                	if(localStorage && localStorage.getItem('lari_currentVersion') != null){
                       	$translatePartialLoader.addPart('library.json?version='+localStorage.getItem('lari_currentVersion'));
                       }else{
                       	$translatePartialLoader.addPart('library.json?timestamp='+new Date().getTime());
                       }
                    return $translate.refresh();
                }],
                mdTabIndex:['tabservice','$timeout', function (tabservice,$timeout) {
                	tabservice.setIndex("2");
                	$timeout(function() {
                	    angular.element('#entity').triggerHandler('click');
                	  });
                }]
            }
        });
    }
})();